import { Component, OnInit, ChangeDetectorRef, NgZone, ViewEncapsulation, HostListener } from '@angular/core';
import * as M from "materialize-css/dist/js/materialize";
//import { AngularFireDatabase } from 'angularfire2/database';
import * as _moment from 'moment';
import { saveAs } from 'file-saver';
import { DateTimeAdapter } from 'ng-pick-datetime';
//import * as Chartist from 'chartist';
import { AuthService, DataService } from '../../_services';

@Component({
  selector: 'app-data-report',
  templateUrl: './data-report.component.html',
  styleUrls: ['./data-report.component.css'],
  //encapsulation : ViewEncapsulation.Native
  //changeDetection: ChangeDetectionStrategy.Default
})
export class DataReportComponent implements OnInit {
  public selectedMoment = [new Date(), new Date()];
  //public selectedMoment = [new Date(2019,10,29), new Date(2019,10,29)];
  constructor(
    private ngZone: NgZone,
    private changeDetector : ChangeDetectorRef,
    //public db: AngularFireDatabase,
    public svcAuth: AuthService,
    public svcData: DataService,
    dateTimeAdapter: DateTimeAdapter<any>
  ) { 
    //dateTimeAdapter.setLocale('fr-FR'); // change locale to Japanese
  }
  @HostListener('click', ['$event']) onClick(e) {
    if(e.target.classList.contains('li_area')){
      this.pageData.areaIndex = -1;
      var _title = e.target.innerHTML;
      this.pageData.areas.forEach((rec, iRec)=>{
        if(_title == rec.title){
          this.pageData.areaIndex = iRec
        }
      });
    }
  }
  pageData = {
    account: {
      //fullName: '', email: '', password: '', confirmPassword: '', contactNo: '', imageUrl: '', role: 'ADMIN', title: ''
      fullName: 'Geek', email: 'geek@gmail.com', password: 'pwd4Geek', confirmPassword: 'pwd4Geek', contactNo: '12345678', imageUrl: '', role: 'ADMIN', title: 'Manager'
    },
    viewMode: 'LIST',
    userList: [],
    areas:[],
    areas4Occupancy:[],
    areaIndex: -1,
    inValue: 0, outValue: 0, occupancyValue: 0,
    data: [],
    cDataEntry: [],
    cDataExit: [],
    cDataOccupancy: [],
    autoRefresh: false
  }
  isLoading = true;
  area:any;
  selectedAll = false;
  reportIntervals = [
    {value: 'HOUR', title: 'HOURLY', minute: 60},
    {value: 'DAY', title: 'DAILY', minute: 60*24},
  ];
  iInterval = 0;
  curUserId: any = "";
  isToggled: boolean = false;

  ngOnInit() {
    this.areaListLoad();
    this.curUserId = JSON.parse(localStorage.getItem("currentUser")).userId.toString();
    //console.log(this.curUserId);
  }
  ngAfterViewInit(){
    //console.log('this is ngAfterViewInit');
    this.svcData.usageAdd('{"userId":"'+JSON.parse(localStorage.getItem("currentUser")).userId+'","code":"REPORT-VIEW","actionCode":"REPORT-VIEW"}').subscribe();
  }
  areaListLoad(){
    // this.svcData.areaListAll().subscribe(res=>{ // standalone areas case
    this.svcData.areaListForDashboard().subscribe(res=>{
      if(res.status != 'OK'){
        this.showAlert(res.message);
        return;
      }
      //this.pageData.areas = res.data;
      this.pageData.areas.push({areaId: '0', areaName: '-- ALL --'})
      res.data.forEach(r => {
        this.pageData.areas.push(r);
      });
      var elems = document.querySelectorAll('.dropdown-trigger');
      M.Dropdown.init(elems, {});
      this.areaSelect(this.pageData.areas[0]);
    });
  }
  dataLoad(){
    //this.loading(true);
    var _startTime = _moment(this.selectedMoment[0]).format('YYYYMMDD090000');
    var _endTime = _moment(this.selectedMoment[1]).format('YYYYMMDD235959');
    
    this.svcData.sensorData(this.area.areaId, _startTime, _endTime).subscribe(res=>{
      this.loading(false);
      //console.log(res);
      if(res.status != 'OK'){
        this.showAlert(res.message);
        return;
      }
      this.pageData.inValue = 0;
      this.pageData.outValue = 0;
      this.pageData.data = res.data;
      //console.log(this.pageData.data)

      this.pageData.cDataEntry = [];
      this.pageData.cDataExit = [];
      this.pageData.cDataOccupancy = [];

      var cIntervals = this.chartIntervals();
      cIntervals.forEach(x=>{
        this.pageData.cDataEntry.push(0);
        this.pageData.cDataExit.push(0);
        this.pageData.cDataOccupancy.push(0);
      })

      this.pageData.data.forEach(x=>{
        this.pageData.inValue +=  x.inValue;
        
        var _outValue = 0;
        if(this.pageData.inValue < this.pageData.outValue + x.outValue){
          var _xValue = (this.pageData.outValue + x.outValue) - this.pageData.inValue;
          _outValue = x.outValue - _xValue;
          //this.pageData.outValue 
        }
        else{
          //this.pageData.outValue += x.outValue;
          _outValue = x.outValue;
        }
        this.pageData.outValue += x.outValue;

        var _occupancy = this.pageData.inValue - this.pageData.outValue;
        if(_occupancy<0) _occupancy = 0;
        var iHour = _moment(x.timestamp).format('H');
        this.pageData.cDataEntry[iHour] = x.inValue;
        this.pageData.cDataExit[iHour] = _outValue;
        this.pageData.cDataOccupancy[iHour] = _occupancy;

        //console.log(`${x.inValue} | ${x.outValue} --- ${_outValue}`);
      });
      if(this.pageData.inValue<this.pageData.outValue){
        this.pageData.inValue = this.pageData.outValue;
      }
      this.pageData.occupancyValue = this.pageData.inValue - this.pageData.outValue;
      if(this.pageData.occupancyValue<0) this.pageData.occupancyValue = 0;

      //this.chartBind();
    });
  }
  dataLoad4Occupancy(){
    this.pageData.areas4Occupancy = [];
    //console.log('today');
    this.svcData.areaListForOccupancy().subscribe(res=>{
      //console.log(res);
      if(res.status != 'OK'){
        this.showAlert(res.message);
        return;
      }
      this.pageData.areas4Occupancy = res.data;
      var _loadedOA = 0;
      this.pageData.areas4Occupancy.forEach(rec=>{
        rec.occupancyTitle = '-';
        var _startTime = _moment(this.selectedMoment[0]).format('YYYYMMDD090000');
        var _endTime = _moment(this.selectedMoment[1]).format('YYYYMMDD235959');

        
        this.svcData.sensorData(rec.areaId, _startTime, _endTime).subscribe(resOccupancy=>{
          _loadedOA++;
          if(resOccupancy.status != 'OK'){
            this.showAlert(resOccupancy.message);
            return;
          }
          var _dataOccupancy = resOccupancy.data;

          this.pageData.cDataEntry = [];
          this.pageData.cDataExit = [];
          this.pageData.cDataOccupancy = [];

          var cIntervals = this.chartIntervals();
          cIntervals.forEach(x=>{
            this.pageData.cDataEntry.push(0);
            this.pageData.cDataExit.push(0);
            this.pageData.cDataOccupancy.push(0);
          })

          var _inValue = 0, _outValue = 0;
          _dataOccupancy.forEach(x=>{
            _inValue +=  x.inValue;

            var _oValue = 0;
            if(_inValue < _outValue + x.outValue){
              var _xValue = (_outValue + x.outValue) - _inValue;
              _oValue = x.outValue - _xValue;
            }
            else{
              _oValue = x.outValue;
            }
            _outValue += _oValue;
            //_outValue += x.outValue;

            var _occupancy = _inValue - _outValue;
            if(_occupancy<0) _occupancy = 0;
          });
          rec.occupancyTitle = _inValue - _outValue;
          if(rec.occupancyTitle <0) rec.occupancyTitle = 0;
          if(_loadedOA == 3){  //-- DMS
            console.log('DMS - Occupancy');
            //console.log(this.pageData.areas4Occupancy);
          }
        });
      });
    });
  }
  dateChange(){
    //console.log(this.selectedMoment);
    //this.dataLoad();
    this.dataLoad4Sensor();
  }
  areaSelect(arg){
    this.svcData.areaDetail(arg.areaId).subscribe(res=>{
      if(res.status != 'OK'){
        this.showAlert(res.message);
        return;
      }
      //console.log(res.data);
      this.area = res.data;
      if(arg.areaId == '0'){
        this.area.areaId = '0';
        this.area.areaName = '-- ALL --';
      }
      //this.dataLoad4Sensor();
      this.isLoading = false;

      this.area.sensors.forEach(s => {
        s.selected = false;
      });

      this.selectedAll = false;
      this.pageData.viewMode = 'LIST';
    });
  }
  dataLoad4Sensor():boolean{
    var _startTime = _moment(this.selectedMoment[0]).format('YYYYMMDD') + _moment(this.area.openingTime).format('HH0000');
    var _endTime = _moment(this.selectedMoment[1]).format('YYYYMMDD') + _moment(this.area.closingTime).format('HH5959');

    //console.log(_startTime);
    //console.log(_endTime);

    //console.log(this.area.areaId);
    var _arr = this.area.sensors.filter(s=>s.selected);
    if(_arr.length<1){
      this.showAlert('Please select one or more sensor to view the data!');
      return false;
    }

    var _sensors = [];
    _arr.forEach(r => {
      _sensors.push({sensorId: r.sensorId});
      r.sData = this.dataIntervals();
    });

    var _isSameDate = this.isSameDate();
    //var _frequencyMinute = this.reportIntervals[this.iInterval].minute;
    var _frequencyMinute = _isSameDate ? 60 : (60*24);
    var _json = JSON.stringify(_sensors);
    this.loading();

    this.area.intervals = this.dataIntervals();
    
    this.svcData.sensorDataListByFrequencyMinute(this.area.areaId, _json, _startTime, _endTime, this.area.timezoneMinute, _frequencyMinute).subscribe(res=>{
      this.loading(false);
      //console.log(res.data);
      if(res.status != 'OK'){
        this.showAlert(res.message);
        return;
      }
      //console.log(res.data);
      res.data.forEach(r => {
        var _rTimeCode = _moment(r.timestamp).format('YYYYMMDDHHmm');        
        _arr.forEach(s => {
          if(r.sensor.sensorUuid == s.sensorId){
            s.data = true;
            s.sData.forEach(sd => {
              if(sd.timeCode == _rTimeCode){
                sd.inValue += r.inValue;
                sd.outValue += r.outValue;
                sd.inValueT002 += r.inValueT002;
                sd.outValueT002 += r.outValueT002;
              }
            });
          }
        });
      });
    });
    return true;
  }
  dataIntervals(){
    var _sd = _moment(this.selectedMoment[0]).format('YYYYMMDD');
    var _ed = _moment(this.selectedMoment[1]).format('YYYYMMDD');
    var _arr = [];
    if(_sd == _ed){
      var _sH = _moment(this.area.openingTime).hour();
      var _eH = _moment(this.area.closingTime).hour();
      for(var i=_sH; i<=_eH; i++){
        var _hr = `${i}`.length < 2 ? `0${i}` : i;
        _arr.push({time: i+'hr', inValue: 0, outValue: 0,inValueT002: 0, outValueT002: 0, occ: 0, timeCode: `${_sd}${_hr}00`});
      }
      return _arr;
    }
    else{
      var _ds = _moment(this.selectedMoment[0]).startOf('day');
      while(_ds <= _moment(this.selectedMoment[1]).startOf('day')){
        _arr.push({time: _moment(_ds).format('DD/MMM'), inValue: 0, outValue: 0,inValueT002: 0, outValueT002: 0, timeCode: _moment(_ds).format('YYYYMMDD0000')});
        _ds = _moment(_ds).add(1, 'day');
      }
      return _arr;
    }
  }
  isSameDate():boolean{
    return _moment(this.selectedMoment[0]).format('YYYYMMDD') == _moment(this.selectedMoment[1]).format('YYYYMMDD');
  }
  dataLoad4SensorV01(){
    var _startTime = _moment(this.selectedMoment[0]).format('YYYYMMDD') + _moment(this.area.openingTime).format('HH0000');
    var _endTime = _moment(this.selectedMoment[1]).format('YYYYMMDD') + _moment(this.area.closingTime).format('HH5959');
    //var _startTime = _moment(this.selectedMoment[0]).format('YYYYMMDD090000');
    //var _endTime = _moment(this.selectedMoment[1]).format('YYYYMMDD235959');
    var _sH = _moment(this.area.openingTime).hour();
    var _eH = _moment(this.area.closingTime).hour(); 
    this.area.intervals = this.timeValueList(_sH, _eH);
    this.area.sData = this.timeValueList(_sH, _eH);
    this.area.oData = this.timeValueList(_sH, _eH);
    this.pageData.inValue = 0;
    this.pageData.outValue = 0;
    var _loadedCount = 0;
    this.isLoading = true;
    //if(1==1) return;
    //console.log(this.area);
    if(this.area.areaId != '0'){
      this.area.sensors.forEach((s, iS) => {
        this.svcData.sensorDataBySensor(this.area.areaId, s.sensorId, _startTime, _endTime).subscribe(d=>{
          _loadedCount++;
          //console.log(d);
          if(d.status != 'OK'){
            this.showAlert(d.message);
            return;
          }
          s.data = d.data;
          s.sData = this.timeValueList(_sH, _eH);
          s.data.forEach(sData => {
            s.sData.forEach((t, iT) => {
              if(t.time == _moment(sData.timestamp).format('H') + 'hr'){
                t.inValue += sData.inValue;
                t.outValue += sData.outValue;
                //console.log(t);
  
                this.area.sData[iT].inValue += sData.inValue;
                this.area.sData[iT].outValue += sData.outValue;
  
                this.pageData.inValue += sData.inValue;
                this.pageData.outValue += sData.outValue;
              }
            });
          });
          console.log(`${_loadedCount} of ${this.area.sensors.length}`);
          if(_loadedCount == this.area.sensors.length){
            this.isLoading = false;
            var _occupancy = 0;
            this.area.sData.forEach((d, iD) => {
              _occupancy += d.inValue - d.outValue;
              if(_occupancy<0) _occupancy = 0;
              this.area.oData[iD].inValue = _occupancy;
            });
            // var _self = this;
            // window.setTimeout(function(){
            //   var _occupancy = 0;
            //   _self.area.sData.forEach((d, iD) => {
            //     _occupancy += d.inValue - d.outValue;
            //     if(_occupancy<0) _occupancy = 0;
            //     _self.area.oData[iD].inValue = _occupancy;
            //   });
            // }, 500);
            //console.log('here all done');
          }
        });
      });
    }
    else{
      var _delay = 0;
      var _self = this;

      var _selectedCount = 0;
      this.area.sensors.forEach((s, iS) => {
        if(s.selected) _selectedCount ++;
      });
      if(_selectedCount==0){
        this.showAlert('No sensor is selected!');
        this.pageData.viewMode = 'LIST';
        this.isLoading = false;
        return;
      }
      var _frequencyMinute = this.reportIntervals[this.iInterval].minute;
      this.area.sensors.forEach((s, iS) => {
        if(!s.selected) return;
        setTimeout(function(){
          _self.svcData.sensorDataBySensorAloneByFrequencyMinute(s.sensorId, _startTime, _endTime, _self.area.timezoneMinute, _frequencyMinute).subscribe(d=>{
            _loadedCount++;
            //console.log(_loadedCount + ' vs ' + _selectedCount);
            //console.log(d);
            if(_loadedCount == _selectedCount){
              _self.isLoading = false;
            }
            if(d.status != 'OK'){
              _self.showAlert(d.message);
              return;
            }
            s.data = d.data;
            //console.log('interval i: ' + _self.iInterval);
            if(_self.iInterval == 1){
              s.sData = _self.timeValueListDaily();
            }
            else{
              s.sData = _self.timeValueList(_sH, _eH);
            }
            s.data.forEach(sData => {
              s.sData.forEach((t, iT) => {
                if(t.time == _moment(sData.timestamp).format('H') + 'hr'){
                  t.inValue += sData.inValue;
                  t.outValue += sData.outValue;
    
                  _self.area.sData[iT].inValue += sData.inValue;
                  _self.area.sData[iT].outValue += sData.outValue;
    
                  _self.pageData.inValue += sData.inValue;
                  _self.pageData.outValue += sData.outValue;
                }
              });
            });
    
            //console.log(`${_loadedCount} of ${_selectedCount}`);
            if(_loadedCount == _selectedCount){
              var _occupancy = 0;
              _self.area.sData.forEach((d, iD) => {
                _occupancy += d.inValue - d.outValue;
                if(_occupancy<0) _occupancy = 0;
                _self.area.oData[iD].inValue = _occupancy;
              });
              // var _self = this;
              // window.setTimeout(function(){
              //   var _occupancy = 0;
              //   _self.area.sData.forEach((d, iD) => {
              //     _occupancy += d.inValue - d.outValue;
              //     if(_occupancy<0) _occupancy = 0;
              //     _self.area.oData[iD].inValue = _occupancy;
              //   });
              // }, 500);
              //console.log('here all done');
            }
          });
        }, _delay*iS);
      });
    }
  }
  dataView(){
    var _res = this.dataLoad4Sensor();
    if(_res) this.pageData.viewMode = 'DATA';
  }
  chartIntervals(){
    var arrHr = [];
    for(var i=0;i<24;i++){
      arrHr.push(i + 'hr');
    }
    return arrHr;
  }
  
  dataExportCsv() {
    // const replacer = (key, value) => value === null ? '' : value; // specify how you want to handle null values here
    // const header = Object.keys(data[0]);
    // let csv = data.map(row => header.map(fieldName => JSON.stringify(row[fieldName], replacer)).join(','));
    // csv.unshift(header.join(','));
    // let csvArray = csv.join('\r\n');

    // var blob = new Blob([csvArray], {type: 'text/csv' })
    // saveAs(blob, "Attendance_AuditLog.csv");

    var _nl = '\r\n';
    var csv = _moment(this.selectedMoment[0]).format('D/MM/YYYY') + ',';
    this.area.intervals.forEach(x => {
      // csv += x.time + ',,';
      if(this.isToggled){
        csv += x.time + ',';
      }
      else{
        csv += x.time + ',,';
      }
    });
    csv += _nl;
    // csv += `${this.area.areaName},`;
    // this.area.sData.forEach(d => {
    //   csv += `${d.inValue},${d.outValue},`;
    // });
    //console.log(csv);
//console.log(this.area.sensors);
    this.area.sensors.forEach(s => {
      if(!s.selected) return;
      csv += _nl + s.sensorId + ',';
      s.sData.forEach(sd => {
        // csv += `${sd.inValue},${sd.outValue},`;
        if(this.isToggled){
          csv += `${sd.inValue},`;
        }
        else{
          csv += `${sd.inValue},${sd.outValue},`;
        }
      });
    });
    var blob = new Blob([csv], {type: 'text/csv' })
    saveAs(blob, "exportData.csv");

  }
  intervalSelect(rec, iRec){
    this.iInterval = iRec;
  }
  onSubmit(){
    if(this.pageData.account.fullName.length<1){
      this.showAlert('Full Name should not be empty!');
      return;
    }
    if(this.pageData.account.email.length<1){
      this.showAlert('Email should not be empty!');
      return;
    }
    if(this.pageData.account.title.length<1){
      this.showAlert('Title should not be empty!');
      return;
    }
    if(this.pageData.account.password.length<1){
      this.showAlert('Password should not be empty!');
      return;
    }
    if(this.pageData.account.password.length<8){
      this.showAlert('Minimum password length is 8!');
      return;
    }
    if(this.pageData.account.password != this.pageData.account.confirmPassword){
      this.showAlert('Password and Confirm Password mismatch!');
      return;
    }
    if(this.pageData.account.contactNo.length<1){
      this.showAlert('Contact Number should not be empty!');
      return;
    }
    this.loading(true);
    // this.svcAuth.signUp(this.pageData.account.email, this.pageData.account.password).then( res=>{
    //   //console.log(res);
    //   this.db.list('/accounts').push({
    //     uid: res.user.uid,
    //     fullName: this.pageData.account.fullName, 
    //     email: this.pageData.account.email,
    //     title: this.pageData.account.title,
    //     contactNo: this.pageData.account.contactNo,
    //     role: this.pageData.account.role,
    //     imageUrl: this.pageData.account.imageUrl
    //   });
    //   this.loading(false);
    //   this.pageData.viewMode = 'LIST';
    // })
    // .catch(err=>{
    //   this.loading(false);
    //   this.showAlert(err);
    //   //this.changeDetector.detectChanges();
    // });
  }
  selectAll(){
    this.area.sensors.forEach(s => {
      s.selected = this.selectedAll;
    });
  }
  loading(arg=true){
    var _self = this;
    this.ngZone.run(()=>{ _self.isLoading = arg; });
  }
  showAlert(msg){
    //alert(msg);
    M.toast({html: msg});
  }
  timeValueList(startHour, endHour){
    var _arr = [];
    for(var i=startHour; i<=endHour; i++){
      _arr.push({time: i+'hr', inValue: 0, outValue: 0, occ: 0});
    }
    return _arr;
  }
  timeValueListDaily(){
    var _arr = [];
    var _startDate = _moment(this.selectedMoment[0]).toDate();
    while(_startDate <= this.selectedMoment[1]){
      _arr.push({time: _moment(_startDate).format('DD/MMM'), inValue: 0, outValue: 0, occ: 0});
      _startDate = _moment(_startDate).add(1, 'day').toDate();
    }
    //console.log(_arr);
    return _arr;
  }
  userForm(arg){
    this.pageData.viewMode = 'FORM';
  }

  entryOnlyTgl(){
    this.isToggled = !this.isToggled;
  }
  
}
